// WebsiteData.js

const teamData = [
  {
    name: "Bhogi Sumasri",
    rollNumber: "20VV1A1208",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Bollapragada Lalitha Sai Gayathri",
    rollNumber: "20VV1A1210",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Bontalakoti Saikiran",
    rollNumber: "20VV1A1211",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Dwarampudi Hari Sankar Reddy",
    rollNumber: "20VV1A1214",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Gattu Durga Bhavani",
    rollNumber: "20VV1A1216",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Haneesh Bandaru",
    rollNumber: "20VV1A1220",
    year: "2023-2024",
    linkedin: "https://www.linkedin.com/in/haneesh-bandaru/",
    github: "https://github.com/haneesh-bandaru",
    instagram: "https://www.instagram.com/haneesh_bandaru/",
    email: "mailto:haneesh.bandaru@gmail.com",
    website: "https://haneeshbandaru.works/",
    image: "",
    position: "Frontend Developer",
    branch: "Information Technology",
  },
  {
    name: "Jadyada Deekshika",
    rollNumber: "20VV1A1222",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Jammu Saikiran",
    rollNumber: "20VV1A1223",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Karedla Aditya Lakshmi Narayana",
    rollNumber: "20VV1A1225",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Karri Venkata Ramana",
    rollNumber: "20VV1A1226",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Karupati Vivekananda",
    rollNumber: "20VV1A1227",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Machavarapu Mohan Durga Pradeep",
    rollNumber: "20VV1A1232",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Malla Naga Venkata Prasanth Naidu",
    rollNumber: "20VV1A1233",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Manda Sai Sita Maha Laxmi",
    rollNumber: "20VV1A1234",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Mareedu Lokesh",
    rollNumber: "20VV1A1235",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Mudunuru Amrutha",
    rollNumber: "20VV1A1239",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Nalla Adarsh",
    rollNumber: "20VV1A1241",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Nekkalapudi Siva Rama Krishna",
    rollNumber: "20VV1A1242",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Nulu Prameela",
    rollNumber: "20VV1A1243",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Paleti Sowmya",
    rollNumber: "20VV1A1244",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Pedapati Deekshitha",
    rollNumber: "20VV1A1248",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Rangala Dilleswara Rao",
    rollNumber: "20VV1A1253",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Rangisetti Bindu Harshitha",
    rollNumber: "20VV1A1254",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Robba Sangeetha",
    rollNumber: "20VV1A1255",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Shaik Vali Basha",
    rollNumber: "20VV1A1257",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Tammuluri Lokesh",
    rollNumber: "20VV1A1258",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Thiruvayapeta Srimanth Kumar",
    rollNumber: "20VV1A1259",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Uppala Kirtana",
    rollNumber: "20VV1A1261",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "",
    branch: "",
  },
  {
    name: "Dannana Sai Ajith Kumar",
    rollNumber: "21VV5A1268",
    year: "2023-2024",
    linkedin: "https://www.linkedin.com/in/saiajithkumardannana/",
    github: "https://github.com/dsak07",
    instagram: "https://www.instagram.com/sai_ajith_kumar/",
    email: "mailto:dsak.official@gmail.com",
    website: "https://dsak.in/",
    image: "",
    position: "Frontend Developer",
    branch: "Information Technology",
  },
  {
    name: "Golukonda Anusha",
    rollNumber: "21VV5A1269",
    year: "2023-2024",
    linkedin: "",
    github: "",
    instagram: "",
    email: "",
    website: "",
    image: "",
    position: "Frontend Developer",
    branch: "Information Technology",
  },
  {
    name: "Anil Sinthu",
    rollNumber: "22VV5A1273",
    year: "2024-2025",
    linkedin: "https://www.linkedin.com/in/anilsinthu/",
    github: "https://github.com/anilsinthu73",
    instagram: "https://www.instagram.com/mr.anil_sinthu/",
    email: "mailto:anilsinthu114@gmail.com",
    website: "https://anilsinthu.vercel.app/",
    image: "",
    position: "Full Stack Developer",
    branch: "Information Technology",
  },
  {
    name: "Harsha Vivek Gangadhar",
    rollNumber: "21VV1A1203",
    year: "2024-2025",
    linkedin: "https://www.linkedin.com/in/harsha-vivek-a47309243/",
    github: "https://github.com/harsha-vivek03",
    instagram: "https://www.instagram.com/the_hidden_hate/",
    email: "mailto:hvgnani79813@gmail.com",
    website: "https://harsha-vivek03.github.io/personalportfolio/",
    image: "",
    position: "Frontend Developer",
    branch: "Information Technology",
  },
];

export default teamData;

